import { render, staticRenderFns } from "./AlfProducts.vue?vue&type=template&id=535134c1&scoped=true&"
import script from "./AlfProducts.vue?vue&type=script&lang=js&"
export * from "./AlfProducts.vue?vue&type=script&lang=js&"
import style0 from "./AlfProducts.vue?vue&type=style&index=0&id=535134c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535134c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535134c1')) {
      api.createRecord('535134c1', component.options)
    } else {
      api.reload('535134c1', component.options)
    }
    module.hot.accept("./AlfProducts.vue?vue&type=template&id=535134c1&scoped=true&", function () {
      api.rerender('535134c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/AlfProducts.vue"
export default component.exports